exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'Arial-BoldMT';\n  src: url(" + require("./assets/fonts/Arial-BoldMT.ttf") + ") format(\"opentype\"); }\n\n@font-face {\n  font-family: 'Arial-MT';\n  src: url(" + require("./assets/fonts/Arial-MT.ttf") + ") format(\"opentype\"); }\n\n@font-face {\n  font-family: 'Arial-ItalicMT';\n  src: url(" + require("./assets/fonts/Arial-ItalicMT.ttf") + ") format(\"opentype\"); }\n\nbody {\n  margin: 0;\n  padding: 0;\n  height: auto; }\n  body .container-fluid {\n    padding-left: em(0); }\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: Arial-BoldMT !important; }\n\np, th, td {\n  font-family: Arial-MT !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/index.scss
// module id = 197
// module chunks = 0